// Shared formatting and labels for the attendance screens (agent panel and
// admin dashboard both render the same durations and states).

// Break types are configured by the admin, so the name of a break comes from
// the record itself: the server snapshots the label when the break is taken,
// which is what keeps old records readable after a type is renamed or retired.
// The key is the fallback for breaks logged before that snapshot existed.
export const breakLabel = (b) => b?.typeLabel || b?.type || "Break";

export const STATE_META = {
  clocked_in: { label: "Clocked In", color: "#059669", bg: "#ecfdf5" },
  on_break: { label: "On Break", color: "#d97706", bg: "#fffbeb" },
  clocked_out: { label: "Clocked Out", color: "#6b7280", bg: "#f3f4f6" },
  off: { label: "Not Clocked In", color: "#6b7280", bg: "#f3f4f6" },
};

/** "07:32:15" -- the running form used on the big timer. */
export const formatClock = (ms) => {
  const total = Math.max(0, Math.floor((ms || 0) / 1000));
  const h = String(Math.floor(total / 3600)).padStart(2, "0");
  const m = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
  const s = String(total % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

/** "7h 32m" -- the compact form used in tables and stat tiles. */
export const formatDuration = (ms) => {
  const total = Math.max(0, Math.floor((ms || 0) / 60000));
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (!h) return `${m}m`;
  return `${h}h ${String(m).padStart(2, "0")}m`;
};

/** Wall-clock time of a timestamp, e.g. "09:34 AM". */
export const formatTime = (value) => {
  if (!value) return "--";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "--";
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

export const formatDateTime = (value) => {
  if (!value) return "--";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "--";
  return `${d.toLocaleDateString([], { day: "2-digit", month: "short" })} ${formatTime(d)}`;
};

/** YYYY-MM-DD for <input type="date">, offset by whole days from today. */
export const isoDate = (daysAgo = 0) => {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().slice(0, 10);
};
